import AnimateOnScroll from "@/components/AnimateOnScroll";
import * as StyledLayout from "../Styled.Layout";
import Hero from "@/components/Header/Hero";
import EmailSignup from "@/components/EmailSignup";

const PrimaryLayout = ({ children, heroProps, showEmailSignup = false }) => {
  return (
    <StyledLayout.PageLayoutWrapper>
      <Hero {...heroProps} />
      <AnimateOnScroll>
        {children}
        {/* Conditionally show the email signup */}
        {showEmailSignup && (
          <StyledLayout.Grid>
            <StyledLayout.GridItem data-animate="fade-up">
              <EmailSignup />
            </StyledLayout.GridItem>
          </StyledLayout.Grid>
        )}
      </AnimateOnScroll>
    </StyledLayout.PageLayoutWrapper>
  );
};

export default PrimaryLayout;
